import { PaymentFormValues } from '@entities/payment'
import { getServiceFieldsConfig } from './getServiceFieldsConfig'

interface getPcekServiceParamsByTspUrlArgs {
  isVoucher: boolean
  isGameKey: boolean
  values: PaymentFormValues
  url: string
  fields: Array<{ name: string }>
}

export const getPcekServiceParamsByTspUrl = ({
  isVoucher,
  isGameKey,
  values,
  url,
  fields,
}: getPcekServiceParamsByTspUrlArgs) => {
  const {
    isUidOnlyService,
    isUidAndServerService,
    isUidAndServerAndRegionService,
    isIdAndZoneIdService,
    isIdAndServerService,
    isPlayerIdAndZoneIdService,
    isPlayerIdAndServerService,
    isPlayerIdOnlyService,
    isPubgService,
  } = getServiceFieldsConfig(fields)

  if (isPubgService) {
    return JSON.stringify({ uidPubg: values.uidPubg })
  }

  if (isUidOnlyService) {
    return JSON.stringify({ uid: values.uid })
  }

  if (isUidAndServerService) {
    const isLoveAndDeepspace = url === 'love-and-deepspace'

    if (isLoveAndDeepspace) {
      return JSON.stringify({
        uid: `${values?.uid}:${values?.server}`,
        server: values?.server,
      })
    }

    return JSON.stringify({ uid: values.uid, server: values.server })
  }

  if (isUidAndServerAndRegionService) {
    return JSON.stringify({
      uid: values.uid,
      server: values.server,
      region: values.region,
    })
  }

  if (isPlayerIdAndServerService) {
    return JSON.stringify({
      id: values.id,
      server: values.server,
    })
  }

  if (isIdAndServerService) {
    return JSON.stringify({
      id: values.id,
      server: values.server,
    })
  }

  if (isIdAndZoneIdService) {
    return JSON.stringify({
      id: `${values.id}:${values.zoneId}`,
      zoneId: values.zoneId,
    })
  }

  if (isPlayerIdAndZoneIdService) {
    return JSON.stringify({ id: values.id, zoneId: values.zoneId })
  }

  if (isPlayerIdOnlyService) {
    return JSON.stringify({ playerId: values.playerId })
  }

  const id1 = isVoucher || isGameKey ? values?.email : values?.login

  return JSON.stringify({ id1 /* , region */ })
}
